/**
 * `artists` — les artistes de la galerie (base galerie, 4.1).
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, slugSchema, withAudit } from './commun.js';
/** Contrat de représentation, rattaché au coffre par un document. */
export const representationSchema = z.object({
    representee: z.boolean().default(false),
    depuis: z.date().optional(),
    jusquau: z.date().optional(),
    exclusivite: z.boolean().default(false),
    /** Le contrat lui-même vit dans `documents`. */
    contratId: idSchema.optional(),
});
export const artistSchema = withAudit(z.object({
    _id: idSchema,
    nom: z.string().min(1),
    slug: slugSchema,
    naissance: z.string().optional(),
    nationalite: z.string().length(2).optional(),
    biographie: bilingueSchema.optional(),
    cv: bilingueSchema.optional(),
    presse: bilingueSchema.optional(),
    portraitId: idSchema.optional(),
    representation: representationSchema,
    ordre: z.int().min(0).default(0),
    visibleSurLeSite: z.boolean().default(true),
}));
export const artistCreationSchema = artistSchema.omit(CHAMPS_DOCUMENT);
export const artistMiseAJourSchema = artistCreationSchema.partial();
//# sourceMappingURL=artists.js.map